import { isUndefined } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import './styles/User.css';
import { color } from '../utilities';
import Stat from './Stat';
import OverallStat from './OverallStat';
import SkillIcon from './SkillIcon';
import STAT_LIST from '../constants/statList'

import { actions } from '../actions/user';

const getStat = (stats, statKey) => {
  const stat = stats.find(stat => stat.key === statKey);
  return !isUndefined(stat) ? stat.details : {};
};

const skillMax = level => level > 99 ? 99 : level;

class User extends Component {
  getCombatLevel = (stats = []) => {
    const attack = skillMax(getStat(stats, 'attack').level);
    const defense = skillMax(getStat(stats, 'defense').level);
    const strength = skillMax(getStat(stats, 'strength').level);
    const base = 0.25 * (defense + skillMax(getStat(stats, 'hp').level) + Math.floor(skillMax(getStat(stats, 'prayer').level)/2));
    const melee = 0.325 * (attack + strength);
    const range = 0.325 * (Math.floor(skillMax(getStat(stats, 'ranged').level)/2) + skillMax(getStat(stats, 'ranged').level));
    const mage = 0.325 * (Math.floor(skillMax(getStat(stats, 'magic').level)/2) + skillMax(getStat(stats, 'magic').level));
    const type = (melee >= range && melee >= mage) ?
          (attack >= strength && attack >= defense) ?
            'attack' :
            (strength >= defense) ?
                'strength' :
                'defense' :
            (range >= mage) ?
                'ranged' :
                'magic';
    return {
      type,
      level: Math.floor(base + Math.max(melee, range, mage))
    };
  };

  render() {
    const { user, name, sort, formatting, handleRemove, superiorCheck } = this.props;

    const getSortedStats = (stats = []) => {
      if (sort === 'level') {
        return stats.sort((a, b) => b.details.exp - a.details.exp);
      } else {
        return stats.sort((a, b) => {
          const indexA = STAT_LIST.findIndex(stat => stat.key === a.key);
          const indexB = STAT_LIST.findIndex(stat => stat.key === b.key);
          return indexA - indexB;
        });
      }
    };

    if (user.isPlaceholder) {
      return (
        <div className="User columns small-12">
          <div className="panel">
            <div className="panel-title user-details">
              <div className="user-username">
                {name}
              </div>
            </div>
            <div className="panel-content collapse">
              {[...Array(24)].map((a, i) => (
                <Stat key={i} isPlaceholder={true} />
              ))}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="User columns small-12">
        <div className="panel">
          <div className="panel-title user-details">
            <div className="user-username">
              {name}
            </div>
            {!user.loaded && (
              <div className="user-loader loader">
                <div className="dot1"></div>
                <div className="dot2"></div>
                <div className="dot3"></div>
              </div>
            )}
            {!user.invalid &&
              <div className="user-combatlevel" style={{ 'background': color.getCombatColor(this.getCombatLevel(user.stats).level) }}>
                <SkillIcon icon={this.getCombatLevel(user.stats).type} name={this.getCombatLevel(user.stats).type} />
                {this.getCombatLevel(user.stats).level}
              </div>
            }
          </div>
          {!user.invalid ?
            <div className="panel-content collapse">
              <OverallStat stat={user.overall} formatting={formatting} stats={user.stats} />
              {getSortedStats(user.stats).map((stat, i) => (
                <Stat key={i} formatting={formatting} isHighestLevel={superiorCheck(user, stat)} stat={stat} />
              ))}
            </div> :
            <div className="panel-content text-center">
              <strong>This guy isn't real.. smdh 🙄</strong>
            </div>
          }
          <div className="panel-footer text-right">
            {user.loaded && <button className="button alert" onClick={() => handleRemove(user.id)}>Remove</button>}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ app }) => ({
  formatting: app.formatting,
});

export default connect(
 mapStateToProps,
 actions
)(User);



// WEBPACK FOOTER //
// ./src/components/User.js